import {
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
  Stack,
  Table,
} from "react-bootstrap";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useEffect, useMemo, useState } from "react";

import CustomModal from "../modal/customModal";
import ReactPaginate from "react-paginate";
import SelectAudience from "../select-audience/select-audience";
import SelectPromotionFilters from "./select-promotion-filters";
import Swal from "sweetalert2";
import TableBodyHover from "../table/table-body-hover";
import TableHeader from "../table/table-header";
import { createBanner } from "../../firebase/firebase.utils";
import { fsTimestampCreador } from "../../firebase/firebase-config";
import { getDisplayNumber } from "./../../firebase/firebase.utils";
import { searchTable } from "./../../custom hooks/search-table/search-table";
import { sortSelectPromoTable } from "../../custom hooks/sort-table/sort-select-promotion-table";
import { useSelector } from "react-redux";

const SelectPromotion = ({ promos, nextStep, setShowStepModal }) => {
  const [promotions, setPromotions] = useState([]);
  const [searchField, setSearchField] = useState("");
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [filteredPromos, setFilteredPromos] = useState([]);

  const [showSelectAudience, setShowSelectAudience] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [displayNumber, setDisplayNumber] = useState(3);
  const { banners } = useSelector((state) => state.banners);
  const [activeBanners, setActiveBanners] = useState();
  const headers = [
    { name: "Sponsor", accessor: "businessName" },
    { name: "Promoción", accessor: "promotion" },
    { name: "Categoría", accessor: "category" },
    { name: "Vencimiento", accessor: "dueDate" },
  ];

  useEffect(() => {
    getNumber();
  }, []);

  const getNumber = async () => {
    const getDisplayN = await getDisplayNumber();
    const displayNumberFromFb = getDisplayN.data().carouselDisplayItems;
    setDisplayNumber(displayNumberFromFb);
    setActiveBanners(banners.filter((b) => b.isActive).length);
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-danger me-2",
    },
    buttonsStyling: false,
  });

  const swalWithBootstrapButtons2 = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-primary me-2",
    },
    buttonsStyling: false,
  });

  const showAlert = () => {
    swalWithBootstrapButtons.fire({
      title: "No se pueden agregar más de 3 banners al carrusel",
      confirmButtonText: "Volver",
    });
    setShowStepModal(false);
  };

  const showAlert2 = () => {
    swalWithBootstrapButtons2.fire({
      title: "Banner creado correctamente",
      confirmButtonText: "Volver",
    });
    setShowStepModal(false);
  };

  const newPromotionsList = useMemo(
    () =>
      promotions
        .filter((a) => a.status === "active")
        .map((promo) => ({
          id: promo.id,
          businessName: promo.businessName ? (
            <Stack
              direction="horizontal"
              gap={2}
              className="align-items-center"
            >
              <div
                className={`${
                  promo.selected ? "bg-primary" : "bg-info"
                } d-inline-block rounded-circle me-1`}
                style={{ width: "15px", height: "15px", flexShrink: 0 }}
                id={promo.id}
              ></div>
              <Image
                src={promo.imageURL}
                width="50px"
                height="50px"
                roundedCircle
                className="me-2"
              />
              <span className="text-truncate">{promo.businessName}</span>
            </Stack>
          ) : (
            "--"
          ),
          promotion: promo.name ? promo.name : "--",
          category: promo.category ? promo.category : "--",
          dueDate: promo.dueDate ? promo.dueDate : "--",
        })),
    [promotions]
  );

  useEffect(() => {
    const endOffset = itemOffset + Number(itemsPerPage);
    setCurrentItems(newPromotionsList.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(newPromotionsList.length / Number(itemsPerPage)));
  }, [itemOffset, newPromotionsList, itemsPerPage]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % newPromotionsList.length;
    setItemOffset(newOffset);
  };

  const sortTableElements = (sortingMethod) => {
    const sortedItems = sortSelectPromoTable(promotions, sortingMethod);
    setPromotions(sortedItems);
  };

  const dropdownList = [
    {
      valuesList: [
        { name: "Más recientes" },
        { name: "Más antiguos" },
        { name: "Orden alfabético" },
      ],
      label: "",
      filterMethod: sortTableElements,
    },
  ];

  useEffect(() => {
    if (promos && promos.length > 0) {
      setPromotions(promos);
    }
  }, [promos]);

  useEffect(() => {
    const selectedPromoItem = promotions.find((promo) => promo.selected);
    setSelectedPromo(selectedPromoItem);
    setDisableBtn(!selectedPromoItem);
  }, [promotions]);

  const cleanSelectedPromo = (id) => {
    const updatedPromotions = promotions.map((promo) => ({
      ...promo,
      selected: promo.id === id ? !promo.selected : false,
    }));
    setPromotions(updatedPromotions);
  };

  const createNewBanner = () => {
    const todayTimestamp = fsTimestampCreador.fromDate(new Date(Date.now()));
    const nextItemNumber = banners.length + 1;
    const bannerData = {
      cdate: todayTimestamp,
      isActive: true,
      itemNumber: nextItemNumber,
      promoRef: selectedPromo.id,
    };

    if (activeBanners >= displayNumber) {
      showAlert();
    } else {
      createBanner(bannerData)
        .then(() => {
          showAlert2();
        })
        .catch((error) => {
          console.error("Error creating banner: ", error);
          Swal.fire("Error", "No se pudo crear el banner.", "error");
        });
    }
  };

  const rows = searchTable(currentItems, headers, searchField);

  return (
    <Card className="border-light p-3">
      <Card.Body>
        <Container fluid className="p-0">
          <Row className="mb-3">
            <Col>
              <SelectPromotionFilters
                dropdowns={dropdownList}
                searchRows={setSearchField}
                barWidth="100%"
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="table-responsive">
                <Table className="bg-light mb-0" hover>
                  <TableHeader headers={headers} />
                  <TableBodyHover
                    rows={rows}
                    columns={headers}
                    searchField={searchField}
                    clickMethod={cleanSelectedPromo}
                    fixedColumnHeight={50}
                  />
                </Table>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mt-3">
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-center justify-content-md-start mb-2 mb-md-0"
            >
              <ReactPaginate
                breakLabel="..."
                nextLabel={<IoIosArrowForward />}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={<IoIosArrowBack />}
                renderOnZeroPageCount={null}
                containerClassName="pagination pagination-modifier"
                pageClassName="page-item"
                previousClassName="page-item"
                nextClassName="page-item"
                pageLinkClassName="page-link page-link-modifier"
                previousLinkClassName="page-link"
                nextLinkClassName="page-link"
                activeClassName="active"
              />
            </Col>
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-center justify-content-md-end"
            >
              <Button
                variant="info"
                className="fw-bold rounded-pill px-4"
                disabled={disableBtn}
                onClick={createNewBanner}
              >
                Crear
              </Button>
            </Col>
          </Row>
        </Container>
      </Card.Body>

      <CustomModal
        show={showSelectAudience}
        handleClose={() => setShowSelectAudience(false)}
        modalTitle={() => "Seleccionar Audiencia"}
        currentSize="lg"
        animated={true}
      >
        <SelectAudience />
      </CustomModal>
    </Card>
  );
};

export default SelectPromotion;
